export enum Status {
  created = 'created',
  determineSpeakersDone = 'determine_speakers_done',
  determineSpeakersFailed = 'determine_speakers_failed',
  determineSpeakersStarted = 'determine_speakers_started',
  failed = 'failed',
  forbiddenLink = 'forbidden_link',
  mergingDone = 'merging_done',
  mergingFailed = 'merging_failed',
  mergingStarted = 'merging_started',
  noAudio = 'no_audio',
  noWords = 'no_words',
  separateBackgroundDone = 'separate_background_done',
  separateBackgroundFailed = 'separate_background_failed',
  separateBackgroundStarted = 'separate_background_started',
  transcribeSegmentsDone = 'transcribe_segments_done',
  transcribeSegmentsFailed = 'transcribe_segments_failed',
  transcribeSegmentsStarted = 'transcribe_segments_started',
  transcriptEdited = 'transcript_edited',
  transcriptionDone = 'transcription_done',
  transcriptionFailed = 'transcription_failed',
  transcriptionStarted = 'transcription_started',
  translationDone = 'translation_done',
  translationFailed = 'translation_failed',
  translationStarted = 'translation_started',
  uploaded = 'uploaded',
  uploadFailed = 'upload_failed',
  uploading = 'uploading',
  voiceEdited = 'voice_edited',
  voiceoverDone = 'voiceover_done',
  voiceoverFailed = 'voiceover_failed',
  voiceoverStarted = 'voiceover_started',
  voiceSuggestDone = 'voice_suggest_done',
  voiceSuggestFailed = 'voice_suggest_failed',
  voiceSuggestStarted = 'voice_suggest_started',
  voiceUpdateDone = 'voice_update_done',
  voiceUpdateFailed = 'voice_update_failed',
  voiceUpdateStarted = 'voice_update_started',
}
